import * as React from 'react';
interface CheckedPDFIconInterface {
    base?: React.ReactElement<any>;
}
type CheckedPDFIconProps = CheckedPDFIconInterface;
class CheckedPDFIcon extends React.Component<CheckedPDFIconProps, {}> {
    render() {
        return (
            <div
                style={{fontSize: '1.8rem'}}
                className="fa-layers fa-fw"
            >
                <span style={{color: '#bd030396'}}>
                    <i className="fas fa-file-pdf"/>
                </span>
                <span style={{fontSize: '1.07rem', color: 'green'}}>
                    <i className={'fas fa-circle '} data-fa-transform="right-9 up-9"/>
                    <i
                        className="fas fa-inverse fa-check"
                        data-fa-transform="right-9 up-9 shrink-6"
                    />
                </span>
            </div>
        );
    }
}

export default CheckedPDFIcon;